import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { QuestionnaireName } from "@/Common/Models/Questionnaires/QuestionnaireName";
import { QuestionnaireFormAdminView } from "./QuestionnaireFormAdminView";

interface IQuestionnairesTabProps {
    availableQuestionnaires: QuestionnaireName[];
}

class QuestionnairesTabState {
    public questionnairesToDisplay: QuestionnaireName[];
    public selectedQuestionnaireId: string;
    public searchText: string;

    public leftMenuOpen: boolean;
}

class QuestionnairesTab extends BaseReactComponent<IQuestionnairesTabProps, QuestionnairesTabState> {
    public constructor(props: Readonly<IQuestionnairesTabProps>) {
        super(props);
        this.state = {
            questionnairesToDisplay: props.availableQuestionnaires || [],
            selectedQuestionnaireId: props.availableQuestionnaires[0]?.QuestionnaireId,
            searchText: "",
            leftMenuOpen: true
        };
    }

    public render(): JSX.Element {
        return (
            <div style={{ height: "90vh" }}>
                <div className="admin-users-container" style={{ height: "100%" }}>

                    {this.state.leftMenuOpen && this.renderLeftMenu()}

                    <div className="aside-handle responsive">
                        <div onClick={() => this.mutateState(s => s.leftMenuOpen = !s.leftMenuOpen)} className="slide-menu-icon blue">
                            <span />
                            <span />
                            <span />
                        </div>
                    </div>
                    {this.renderMainView()}
                </div>
            </div>
        );
    }

    private renderLeftMenu(): JSX.Element {
        return (
            <div className="transition full-border admin-users-search">
                <div className="user-search">
                    <div className="flex-container">
                        <div className="search-field" style={{ width: "100%", maxHeight: "40px" }}>
                            <div className="gf">
                                <span className="glyphicon glyphicon-search" />
                            </div>
                            <div style={{ width: "100%" }}>
                                <TextboxControl
                                    onMountFocus={true}
                                    debounceMs={400}
                                    value={this.state.searchText}
                                    name="questionnaires_text_search"
                                    className="fullWidth"
                                    onChange={text => this.handleSearchTextChanged(text)}
                                    placeholder={cacheStore.GetString("SearchLabel")}
                                    autoComplete="off"
                                    autoCompleteItems={null}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="user-search-results scrollable">
                    <div className="pointer">
                        {this.state.questionnairesToDisplay.map(x => {
                            let selectedClass = "";
                            if (this.state.selectedQuestionnaireId != null) {
                                selectedClass = (x.QuestionnaireId === this.state.selectedQuestionnaireId) ? " selected" : "";
                            }

                            return (
                                <div
                                    className={"user-search-item" + selectedClass}
                                    key={x.QuestionnaireId}
                                    onClick={() => this.mutateState(s => s.selectedQuestionnaireId = x.QuestionnaireId)}
                                    title={cacheStore.getQuestionnaireName(x.QuestionnaireId)}
                                >
                                    <div className="flex-container medical-note" style={{ fontWeight: "bold" }}>
                                        {cacheStore.getQuestionnaireName(x.QuestionnaireId)}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    private renderMainView(): JSX.Element {
        return (
            <QuestionnaireFormAdminView
                questionnaireId={this.state.selectedQuestionnaireId}
            />
        );
    }

    private handleSearchTextChanged(text: string): void {
        let questionnairesToDisplay = this.props.availableQuestionnaires;

        if (!IsNullOrWhiteSpace(text)) {
            questionnairesToDisplay = questionnairesToDisplay.filterSearch(text, s => cacheStore.getQuestionnaireName(s.QuestionnaireId));
        }

        this.mutateState(s => {
            s.searchText = text;
            s.questionnairesToDisplay = questionnairesToDisplay;
            s.selectedQuestionnaireId = s.questionnairesToDisplay[0]?.QuestionnaireId;
        });
    }
}

export { QuestionnairesTab };
